module.exports = __webpack_public_path__ + "static/feedback-d6ff9446b0649d7c21542a44e1f205e9.png";